import { Text } from '@cinch-labs/design-system'
import cx from 'classnames'
import Car from '../assets/car.svg'
import styles from './product-image.module.css'

interface Props {
  isAvailable?: boolean
  image?: string
  unavailableImageMessage: string
  unavailableVehicleMessage?: string
  alt: string
  isPending: boolean
  children?: React.ReactNode
}

interface UnavailableProps extends Props {
  isAvailable: false
  unavailableVehicleMessage: string
}

export const ProductImage: React.FC<Props | UnavailableProps> = ({
  isAvailable,
  image,
  alt,
  children,
}) => (
  <div className={styles.imgContainer}>
    {image && image.length > 0 ? (
      <img
        className={cx(styles.img, { [styles.unavailable]: !isAvailable })}
        src={image}
        alt={alt}
      />
    ) : (
      <div
        className={cx(styles.holdingImage, {
          [styles.holdingImageUnavailable]: !isAvailable,
        })}
      >
        <Car className={styles.holdingImageIcon} fill={'currentColor'} />
        <Text type={'menuTitle'}>Image unavailable</Text>
      </div>
    )}
    {children}
  </div>
)
